module.exports = {
    api: {
        baseUrl: '/api',
    },
};
